import Tasks from 'APP/Tasks';
import { PayloadType } from 'APP/model/message/messageModel.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

const STAY_PAYLOAD_TYPES: PayloadType[] = [PayloadType.Sticker, PayloadType.Location];

export function clearInputPanel(groupId: string, messages: ChatMessage[]): void {
  const isStayInputPanel = messages.some((message) => {
    return STAY_PAYLOAD_TYPES.includes(message.payload.payloadType);
  });

  Tasks.messaging.clearInputPanel(groupId, !isStayInputPanel);
}
